/* import __COLOCATED_TEMPLATE__ from './yield-area.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();